import { render, staticRenderFns } from "./toBeShipped.vue?vue&type=template&id=82c4ee6a"
import script from "./toBeShipped.js?vue&type=script&lang=js&external"
export * from "./toBeShipped.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports